import { GlobalConst } from '../appConfig/globalConst';
import { deleteCookie } from '../helpers/mainHelper';
import { updateToken } from './reducers/authReducer';
import { clearUserPermissions } from './reducers/globalReducer';
import store from './store';

export const checkAuthToken = async () => {

  const urlParams = new URLSearchParams(window.location.search);
  const logoutValue = urlParams.get('logout'); // Replace 'yourParamName' with the actual parameter name
  // const plan = urlParams.get("plan");

  // if (plan) {
  //   localStorage.setItem('plan', plan);
  // }

  // let hasLoggedOut = await localStorage.getItem('logout');

  if (logoutValue && logoutValue === 'yes') {
    localStorage.removeItem('__t');
    localStorage.removeItem('__r');
    deleteCookie();
    store.dispatch(clearUserPermissions());
    // window.location.reload();
    // return false;
  }

  const token = localStorage.getItem('__t');
  // Read the parameter from the URL
  // const urlParams = new URLSearchParams(window.location.search);
  const paramValue = urlParams.get('redirect_url'); // Replace 'yourParamName' with the actual parameter name

  // Store the parameter value in localStorage if it exists
  if (paramValue) {
    localStorage.setItem('redirect_url', paramValue); // Replace 'yourStorageKey' with your preferred key name
  }



  if (token) {

    const refreshToken = localStorage.getItem('__r');
    await store.dispatch(updateToken(token));
    document.cookie = `session_token=${token};domain=${GlobalConst.COOKIE_DOMAIN};path=/;secure`;
    document.cookie = `refresh_token=${refreshToken};domain=${GlobalConst.COOKIE_DOMAIN};path=/;secure`;
  }

};